import React, { Component } from 'react';

class MetamaskInstructions extends Component {
    render() {
        return (
            <div className="metamask-instructions">
              To post projects for others to find, follow these steps:
              <ul>
                <li>
                  First install the <a href='https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn'>Metamask</a> chrome plug-in.
                </li>
                <li> Create a new account on your Metamask wallet.
                </li>
                <li> Click on the orange Metamask icon (top-right corner) and switch the network from "Main Ethereum Network" to "Ropsten Test Network".
                </li>
                <li>
                  Get some free Ether for  your new account by going <a href="https://faucet.metamask.io/">here</a>, and clicking "request 1 ether from faucet".
                </li>
              </ul>
            </div>
        );
    }
}

export default MetamaskInstructions;
